export default __webpack_public_path__ + "static/media/others-avatar.99573a5a.png";